/**
 * The possessive form of a name: `"Mokoena Trading's"`, and a bare apostrophe
 * for a name ending in "s" (`"Naidoo Holdings'"`).
 *
 * The name is trimmed first. Trailing full stops and commas are ignored when
 * deciding whether it ends in "s" but kept in the output, so
 * `"Dlamini Associates."` becomes `"Dlamini Associates.'"` and `"Acme Inc."`
 * becomes `"Acme Inc.'s"`. A blank name returns `""`, so a caller can fall back
 * to its own generic label rather than rendering a stray `"'s"`.
 *
 * Spelled by the final LETTER, not by sound, on the same basis as
 * `indefiniteArticle`: a name ending in a silent or sibilant sound other than
 * "s" ("Knox", "Dumas") gets the letter-rule answer.
 */
export function possessive(name) {
    const trimmed = name.trim();
    if (!trimmed)
        return '';
    const stripped = trimmed.replace(/[.,]+$/, '');
    return /s$/i.test(stripped) ? `${trimmed}'` : `${trimmed}'s`;
}
